import jQuery from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';
import Splide from '@splidejs/splide';

let pricingSplide;
//const customAnmation = new CustomAnimation();

function showMonthyPrice() {
  jQuery('.button_monthly').removeClass('button_red');
  jQuery('.button_monthly').addClass('deactive');
  jQuery('.button_yearly').addClass('button_red');
  jQuery('.button_yearly').removeClass('deactive');

  // change price
  let dataMonthlyStarterd01 = jQuery('.pricing_box_starter').data('monthly-01');
  let dataMonthlyStandard01 = jQuery('.pricing_box_standard').data('monthly-01');
  let dataMonthlyPro01 = jQuery('.pricing_box_pro').data('monthly-01');

  jQuery('.price_text_starter_01').html(dataMonthlyStarterd01);
  jQuery('.price_text_standard_01').html(dataMonthlyStandard01);
  jQuery('.price_text_pro_01').html(dataMonthlyPro01);

  let starterdUrl = jQuery('.pricing_box_starter').data('monthly-url');
  let standardUrl = jQuery('.pricing_box_standard').data('monthly-url');
  let proUrl = jQuery('.pricing_box_pro').data('monthly-url');

  jQuery('.button_starter').attr('href', starterdUrl);
  jQuery('.button_standard').attr('href', standardUrl);
  jQuery('.button_pro').attr('href', proUrl);

}

function showMYearlyPrice() {
  jQuery('.button_yearly').removeClass('button_red');
  jQuery('.button_yearly').addClass('deactive');

  jQuery('.button_monthly').addClass('button_red');
  jQuery('.button_monthly').removeClass('deactive');

  // change price
  let dataYearlyStarter01 = jQuery('.pricing_box_starter').data('yearly-01');
  let dataYearlyStandard01 = jQuery('.pricing_box_standard').data('yearly-01');
  let dataYearlyPro01 = jQuery('.pricing_box_pro').data('yearly-01');

  jQuery('.price_text_starter_01').html(dataYearlyStarter01);
  jQuery('.price_text_standard_01').html(dataYearlyStandard01);
  jQuery('.price_text_pro_01').html(dataYearlyPro01);

  let starterUrl = jQuery('.pricing_box_starter').data('yearly-url');
  let standardUrl = jQuery('.pricing_box_standard').data('yearly-url');
  let proUrl = jQuery('.pricing_box_pro').data('yearly-url');
  jQuery('.button_starter').attr('href', starterUrl);
  jQuery('.button_standard').attr('href', standardUrl);
  jQuery('.button_pro').attr('href', proUrl);

}

class Pricing {
  init() {
    this.initPage();
    this.initParallax();
    this.initlistener();
    this.onScroll();
  }

  initPage = () => {
    const slideCount = document.querySelectorAll('.splide_pricing .splide__slide').length;
    pricingSplide = new Splide( '.splide_pricing', {
      type: 'loop',
      perPage: 3,
      focus: 0, // oder 'left' - zeigt ersten Eintrag links an
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
      gap: slideCount === 3 ? '2rem' : 0,
      padding: slideCount === 3 ? 0 : undefined,
      breakpoints: {
        991: {
          perPage: 2,
          focus: false,
          gap: '1rem',
          padding: 0,
        },
        768: {
          perPage: 1,
        },
      },
    });
    pricingSplide.mount();
    requestAnimationFrame(() => {
      pricingSplide.refresh();
    });

    // bg
    jQuery('.pricing_boxes_background').css("background-image", "url("+ jQuery('.pricing_boxes_background').data('bg-image') +")");


    if (slideCount === 3) {
      document.querySelector('.pricing_caroussel_box_holder').classList.add('has-three-slides');
    }
    setTimeout(() => {

    }, 500);

    showMYearlyPrice();
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    //customAnmation.animateHeaderImage('.header_background');
    //customAnmation.animateBgImage('.pricing_boxes_background', '.pricing_boxes')
    //customAnmation.animateBgImage('.pricing_table_background', '.pricing_boxes')
    //customAnmation.animateText('.pricing_boxes_text');
    //customAnmation.animateButtonHolder('.button_holder_pricing_table');
    //customAnmation.animateGroup('.pricing_boxes');
  }

  initlistener = () => {
    jQuery('.button_monthly').click(function(e) {
      e.preventDefault();
      showMonthyPrice();
    });
    jQuery('.button_yearly').click(function(e) {
      e.preventDefault();
      showMYearlyPrice();
    });

    jQuery('.price_toggle_button').click(function() {
      let toggled = jQuery('.price_toggle_button_highlight', jQuery(this)).hasClass('toggle');

      if(toggled == false) {
        // monthly
        jQuery('.price_toggle_button_highlight', jQuery(this)).addClass('toggle');
        jQuery('.left .button_label_holder', jQuery(this) ).removeClass('hightlight');
        jQuery('.right .button_label_holder', jQuery(this) ).addClass('hightlight');

        showMonthyPrice();
      }
      else {
        // yearly
        jQuery('.price_toggle_button_highlight', jQuery(this)).removeClass('toggle');
        jQuery('.left .button_label_holder', jQuery(this) ).addClass('hightlight');
        jQuery('.right .button_label_holder', jQuery(this) ).removeClass('hightlight');

        showMYearlyPrice();
      }
    });
}

  onScroll = () => {

  };
}

export default Pricing;
